import { render, staticRenderFns } from "./GraficoBarras.vue?vue&type=template&id=64b234a0&scoped=true"
import script from "./GraficoBarras.vue?vue&type=script&lang=js"
export * from "./GraficoBarras.vue?vue&type=script&lang=js"
import style0 from "./GraficoBarras.vue?vue&type=style&index=0&id=64b234a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b234a0",
  null
  
)

export default component.exports